import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController, ToastController} from '@ionic/angular';
import {Chart, registerables} from 'chart.js';
import {DefaultComponent} from "../../shared/components/default.component";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {takeUntil} from "rxjs/operators";
import {ConnectorsService} from "./connectors.service";
import {StationsService} from "./stations.service";


@Component({
    selector: 'app-charge',
    templateUrl: './charge.html',
    styleUrls: ['./charge.scss'],
})
export class Charge extends DefaultComponent implements OnInit {
    selectedSegment: string = 'overview';
    transaction: any = {};
    stations: any = [];
    isVisibleConnector: boolean = false;
    connectors: any = [];
    charge: any = {};
    disableSelector:boolean




    constructor(
        private modelCtrl: ModalController,
        router: Router,
        activatedRoute: ActivatedRoute,
        sharedRoutesService: SharedRoutesService,
        private stationsService: StationsService,
        private connectorService: ConnectorsService,
        toastController: ToastController,

    ) {
        super(router, activatedRoute, sharedRoutesService,toastController);
        this.disableSelector = true;

        Chart.register(...registerables);

    }

    ngOnInit() {
        this.getStations();

    }

    segmentChanged(event: any) {
        this.selectedSegment = event.detail.value;
    }

    private onStartClick() {

    }

    private onEndClick() {

    }


    //function to get all categories

    getStations() {
        const queryParams = {
            relation: 'connectors'
        };
        return this.stationsService
            .list(queryParams)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (data) => {
                    this.stations = data.data;
                    console.log('aaaa',this.stations);
                });

    }


    getConnectors(id) {
        console.log('id',id);
        this.isVisibleConnector = true;
        const queryParams = {
            station_id: id
        };
        return this.connectorService
            .list(queryParams)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (data) => {
                    this.connectors = data.data;

                });

    }


    async  startTransaction() {

            const toast = await this.toastController.create({
                message:  'Transaction not started, Station not available or car not plugged it.',
                duration: 1000,
                color: 'dark'
            });
            toast.present();


    }
}
